import { TOTAL_TIMEOUT_DEFAULT } from '@google-cloud/storage/build/src/storage';
import axios, { AxiosResponse } from 'axios';

const GOOGLE_MAPS_API_KEY =
  process.env.GOOGLE_MAPS_API_KEY || 'AIzaSyDjx0QsOIj6kV1G-UkHSzZBtiRwaDQ9TrM';

export const getGeocode = async ({
  street1,
  state,
  city,
  zip,
}: {
  street1: string;
  state: string;
  city: string;
  zip: string;
}) => {
  const address = `${street1} ${state} ${city} ${zip}`;
  const config = {
    method: 'get',
    url: `https://maps.googleapis.com/maps/api/geocode/json?key=${GOOGLE_MAPS_API_KEY}&address=${address}`,
    headers: {},
  };
  const response = await axios(config);
  return response.data;
};

export const getGeocodeStateCodeByZip = async ({ zip }: { zip: string }) => {
  try {
    const config = {
      method: 'get',
      url: `https://maps.googleapis.com/maps/api/geocode/json?key=${GOOGLE_MAPS_API_KEY}&address=${zip}`,
      headers: {},
    };
    const response = await axios(config);

    const stateCode = response?.data?.results[0]?.address_components.find(
      (row: any) => row.types[0] === 'administrative_area_level_1'
    )?.short_name;

    return stateCode;
  } catch (error) {
    console.error('Error getting state code by zip:', error);
    return null;
  }
};

export const getGeocodeLatLng = async (props: {
  street1: string;
  state: string;
  city: string;
  zip: string;
}) => {
  const response = await getGeocode(props);
  const lat = response?.results[0]?.geometry?.location?.lat.toString();
  const lng = response?.results[0]?.geometry?.location?.lng.toString();
  return { lat, lng };
};

export const zipCodeToPlaceName = async (
  zipCode: string,
  countryCode = 'US'
) => {
  try {
    // Fetch data from Google Maps Geocoding API
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${zipCode}|country:${countryCode}&key=${GOOGLE_MAPS_API_KEY}` //this needs to be in the .env should call process.env.GOOGLE_MAP_API_KEY
    );

    if (!response.ok) {
      throw new Error('Failed to fetch data');
    }

    const data = await response.json();

    // Extract place name from the response
    const placeName = data.results[0].formatted_address;

    return placeName;
  } catch (error) {
    console.error('Error converting ZIP code to place name:', error);
    return null;
  }
};

interface DealershipSummaryRow {
  dealer_name: string;
  latitude: string;
  longitude: string;
}

interface PlaceResponse {
  results: Array<{
    place_id: string;
    geometry: { location: { lat: number; lng: number } };
    name?: string;
  }>;
  status: string;
}

export const getPlaceTextSearch = async (
  dealer_summary: DealershipSummaryRow | undefined | null
) => {
  if (!dealer_summary) {
    console.error('Dealer summary is null or undefined');
    return { error: 'Invalid input: Dealer summary is required.' };
  }

  if (
    !dealer_summary.dealer_name ||
    !dealer_summary.latitude ||
    !dealer_summary.longitude
  ) {
    console.error('Dealer summary is missing required fields:', dealer_summary);
    return {
      error: 'Invalid input: Dealer summary is missing required fields.',
    };
  }

  const placeTextSearchUrl = `https://maps.googleapis.com/maps/api/place/textsearch/json?query=${dealer_summary.dealer_name}&location=${dealer_summary.latitude},${dealer_summary.longitude}&radius=10&key=${GOOGLE_MAPS_API_KEY}`;

  try {
    const placeTextSearchResponse: AxiosResponse<PlaceResponse> =
      await axios.get(placeTextSearchUrl);
    if (
      placeTextSearchResponse.status !== 200 ||
      placeTextSearchResponse.data.status !== 'OK'
    ) {
      console.error(
        'Failed to retrieve data from place text search API',
        placeTextSearchResponse.data
      );
      return {
        error: `Places API error: ${placeTextSearchResponse.data.status}`,
      };
    }

    return {
      placeTextSearchData: placeTextSearchResponse.data,
    };
  } catch (error: any) {
    console.error('Error fetching business info:', error.message);
    return { error: 'Failed to fetch business info' };
  }
};

interface PlaceDetailsResponse {
  result: {
    formatted_address: string;
    formatted_phone_number: string;
    name: string;
    rating: number;
    reviews: Array<{
      author_name: string;
      rating: number;
      text: string;
    }>;
    url: string;
    user_ratings_total: number;
  };
  status: string;
}

export const getDealerDetails = async ({ placeId }: { placeId: string }) => {
  try {
    const config = {
      method: 'get',
      url: `https://maps.googleapis.com/maps/api/place/details/json?place_id=${placeId}&key=${GOOGLE_MAPS_API_KEY}`,
      headers: {},
    };
    const response: AxiosResponse<PlaceDetailsResponse> = await axios(config);
    return response.data;
  } catch (error) {
    console.error('Error fetching dealer details:', error);
    throw new Error('Failed to fetch dealer details. Please try again later.');
  }
};

export const getZipCodeFromLatLng = async (lat: number, lng: number) => {
  try {
    const config = {
      method: 'get',
      url: `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAPS_API_KEY}`,
      headers: {},
    };
    const response: AxiosResponse = await axios(config);
    const postal_code = response.data.results[0].address_components.find(
      (row: any) => row.types[0] === 'postal_code'
    )?.short_name;
    console.log('response.data', postal_code);
    return postal_code;
  } catch (error) {
    console.error('Error fetching zip code from latlng:', error);
    return null;
  }
};
